import type { SuggestedFeaturesContent } from '@/core/types';

import { SuggestedFeatures } from '@/containers/blocks/features';

export default function generate({
  content,
  className,
}: {
  content: SuggestedFeaturesContent;
  className?: string;
}) {
  return (
    <SuggestedFeatures
      title={content.title}
      description={content.description}
      items={content.items}
      image={content.image}
      className={className}
    />
  );
}
